
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 55","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.66 9.132h5.02V.387C26.816.268 23.836 0 20.367 0 4.48 0 8.802 17.99 8.17 20.625H.179v9.776h7.988V55h9.795V30.404h7.666l1.216-9.777H17.96c.43-6.471-1.744-11.495 4.7-11.495z","fill":"#3B5999"}})])
          )
        }
      }
    